import React, { memo } from 'react';

const PaginationDots = memo(({ totalPages, currentPage, onPageChange, isAlertCard }) => {
  if (totalPages <= 1) return <div className="h-[4px]" />;

  const prev = (e) => { e.stopPropagation(); onPageChange((currentPage - 1 + totalPages) % totalPages); };
  const next = (e) => { e.stopPropagation(); onPageChange((currentPage + 1) % totalPages); };

  const btnCls = `w-5 h-5 flex items-center justify-center rounded transition-all duration-150 ${
    isAlertCard ? 'text-white hover:bg-white/20' : 'text-[#1d2e61] hover:bg-[#1d2e61]/10'
  }`;

  return (
    <div
      className="flex justify-center items-center gap-2 mt-1.5 mb-0.5"
      onClick={e => e.stopPropagation()}
    >
      <button onClick={prev} aria-label="Página anterior" className={btnCls}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5">
          <path d="M15 18l-6-6 6-6" />
        </svg>
      </button>

      <span className={`text-[10px] font-medium tabular-nums ${isAlertCard ? 'text-white/80' : 'text-gray-500'}`}>
        {currentPage + 1}/{totalPages}
      </span>

      <button onClick={next} aria-label="Página siguiente" className={btnCls}>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5">
          <path d="M9 18l6-6-6-6" />
        </svg>
      </button>
    </div>
  );
});

PaginationDots.displayName = 'PaginationDots';
export default PaginationDots;
